function calendar() {

    let calendarStart = $('._js-calendar-start');
    let calendarEnd   = $('._js-calendar-end');

    if ( calendarStart.length ) {
        let parent = calendarStart.parents('.input');
        calendarStart
            .daterangepicker({
                "singleDatePicker": true,
                "parentEl" : parent,
                "showDropdowns" : true,
                "autoUpdateInput" : false,
                "locale": {
                    "format": "DD.MM.YYYY",
                    "separator": " - ",
                    "weekLabel": "Н",
                    "daysOfWeek": [
                        "Вс",
                        "Пн",
                        "Вт",
                        "Ср",
                        "Чт",
                        "Пт",
                        "Сб"
                    ],
                    "monthNames": [
                        "Январь",
                        "Февраль",
                        "Март",
                        "Апрель",
                        "Май",
                        "Июнь",
                        "Июль",
                        "Август",
                        "Сентябрь",
                        "Октябрь",
                        "Ноябрь",
                        "Декабрь"
                    ],
                    "firstDay": 1
                }
            })
            //.val('')
            .on('apply.daterangepicker', function(ev, picker) {
                let date = picker.startDate.format('DD.MM.YYYY');

                $(this).val(date).change();
                let flag = false;
                if ( calendarEnd.val() != '' ) {
                    flag = true;
                }
                calendarEnd
                    .daterangepicker({
                        'minDate' : date,
                        "singleDatePicker": true,
                        "parentEl" : parent,
                        "showDropdowns" : true,
                        "locale": {
                            "format": "DD.MM.YYYY",
                            "separator": " - ",
                            "weekLabel": "Н",
                            "daysOfWeek": [
                                "Вс",
                                "Пн",
                                "Вт",
                                "Ср",
                                "Чт",
                                "Пт",
                                "Сб"
                            ],
                            "monthNames": [
                                "Январь",
                                "Февраль",
                                "Март",
                                "Апрель",
                                "Май",
                                "Июнь",
                                "Июль",
                                "Август",
                                "Сентябрь",
                                "Октябрь",
                                "Ноябрь",
                                "Декабрь"
                            ],
                            "firstDay": 1
                        }
                    });
                    if ( !flag ) {
                        calendarEnd.val('');
                    }
            })
            .on('keydown', function(){
                if ( calendarEnd.val() === '' ) {
                    console.log('start');
                    calendarStart
                        .val('')
                }
            });
    }

    if ( calendarEnd.length ) {
        let parent = calendarEnd.parents('.input');
        calendarEnd
            .daterangepicker({
                "singleDatePicker": true,
                "parentEl" : parent,
                "showDropdowns" : true,
                "autoUpdateInput" : false,
                "locale": {
                    "format": "DD.MM.YYYY",
                    "separator": " - ",
                    "weekLabel": "Н",
                    "daysOfWeek": [
                        "Вс",
                        "Пн",
                        "Вт",
                        "Ср",
                        "Чт",
                        "Пт",
                        "Сб"
                    ],
                    "monthNames": [
                        "Январь",
                        "Февраль",
                        "Март",
                        "Апрель",
                        "Май",
                        "Июнь",
                        "Июль",
                        "Август",
                        "Сентябрь",
                        "Октябрь",
                        "Ноябрь",
                        "Декабрь"
                    ],
                    "firstDay": 1
                }
            })
            //.val('')
            .on('apply.daterangepicker', function(ev, picker) {
                let date = picker.startDate.format('DD.MM.YYYY');

                $(this).val(date).change();
                let flag = false;
                if ( calendarStart.val() != '' ) {
                    flag = true;
                }
                calendarStart
                    .daterangepicker({
                        'maxDate' : date,
                        "singleDatePicker": true,
                        "parentEl" : parent,
                        "showDropdowns" : true,
                        "locale": {
                            "format": "DD.MM.YYYY",
                            "separator": " - ",
                            "weekLabel": "Н",
                            "daysOfWeek": [
                                "Вс",
                                "Пн",
                                "Вт",
                                "Ср",
                                "Чт",
                                "Пт",
                                "Сб"
                            ],
                            "monthNames": [
                                "Январь",
                                "Февраль",
                                "Март",
                                "Апрель",
                                "Май",
                                "Июнь",
                                "Июль",
                                "Август",
                                "Сентябрь",
                                "Октябрь",
                                "Ноябрь",
                                "Декабрь"
                            ],
                            "firstDay": 1
                        }
                    });
                    if ( !flag ) {
                        calendarStart.val('');
                    }
            })
            .on('keydown', function(){
                if ( calendarStart.val() === '' ) {
                    console.log('end');
                    calendarEnd
                        .val('')
                }
            });
    }
}